<template lang="html">

  <ul class="flex color">
    <li>{{$t('blog.compartir')}}</li>
    <li><a class="fa-brands fa-x-twitter" :href="'http://twitter.com/intent/tweet?text='+data+'&url='+url" target="_blank"></a></li>
    <li><a class="fa fa-facebook" :href="'http://www.facebook.com/sharer.php?u='+url+'&t='+data" target="_blank"></a></li>
    <li><a class="fa fa-pinterest" :href="'http://pinterest.com/pin/create/link/?url='+url" target="_blank"></a></li>
    <li><a class="fa fa-whatsapp" :href="'whatsapp://send?text='+url" data-action="share/whatsapp/share" target="_blank"></a></li>
  </ul>

</template>

<script lang="js">
  export default  {
    name: 'rrss-share',
    props: ['data'],
    data (){
      return {
        url : location.href
      }
    },
    watch : {
      '$route' : function(){
        this.url = location.href;
      }
    }
}
</script>

<style scoped>
.rrss-share {

}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/ficha-blog/rrss-share.vue